import type { MutableRefObject } from 'react';
import { useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { isIOS } from 'react-device-detect';

export function useScrollLock(
  contentElementRef: MutableRefObject<HTMLElement | null>,
  lock = true
) {
  useEffect(() => {
    // temporary fix for IOS devices because it doesn't scroll for them
    if (!lock || isIOS) {
      return;
    }

    let contentElement: HTMLElement | undefined;

    const raf = requestAnimationFrame(() => {
      if (contentElementRef.current) {
        contentElement = contentElementRef.current;
        disableBodyScroll(contentElement, { reserveScrollBarGap: true });
      }
    });

    return () => {
      cancelAnimationFrame(raf);

      if (contentElement) {
        enableBodyScroll(contentElement);
      }
    };
  }, [lock]);

  return null;
}
